onReady(($) => {
    if ($(".cta-banner .video-active")) {
        $('.cta-banner .watch-video')
            .click(function (e) {
                e.preventDefault()
                $(this)
                    .parents(".cta-banner")
                    .find("img")
                    .click();
            });
    }

    const ctaBanners = Array.from(document.querySelectorAll('.cta-banner'))
    for (const ctaBanner of ctaBanners) {
        const ctaButtons = Array.from(ctaBanner.querySelectorAll('.cta-button'))
        for (const ctaButton of ctaButtons) {
            ctaButton.addEventListener('click', (event) =>
                dataLayer.push({
                    event: 'cta-click',
                    interactionType: 'click',
                    moduleName: ctaBanner.dataset.moduleName,
                    elementContent: ctaButton.textContent.replace("\n", '')
                        .trim(),
                    elementType: ctaButton.nodeName,
                    elementClasses: ctaButton.classList.toString(),
                    destinationUrl: ctaButton.href,
                    modulePosition: ctaBanner.dataset.modulePosition,
                    distinctModulePosition: ctaBanner.dataset.distinctModulePosition,
                    moduleTabPosition: ctaBanner.dataset.tabPosition,
                    moduleId: ctaBanner.dataset.moduleId,
                    wpLoggedIn: document.body.classList.contains('logged-in')
                        .toString(),
                }),
            )
        }
    }
});
